import { useQuery } from 'react-query';
import ApiError from '../utils/ApiError';
import { publicRoutes } from '../constants';
import { useRouter } from 'next/router';

async function fetchAuthedUser() {
  const response = await fetch('/api/users/me');
  const responseBody = await response.json();
  if (!response.ok) throw new ApiError(responseBody.message, response.status);
  return responseBody;
}

export default function useAuthedUser() {
  const router = useRouter();
  return useQuery('me', fetchAuthedUser, {
    refetchOnWindowFocus: false,
    enabled: !publicRoutes.includes(router.pathname),
  });
}
